import { complement, compose, curryN, reduce, uniq, flatten, map, reject, difference } from 'ramda';
import moment from 'moment';

const isFalsey = x => !x;

const isString = x => typeof x === 'string';

const isNotString = complement(isString);

const isEmptyString = x => x === '';

const hasSpaces = x => /\s/.test(x);

const trim = x => x.trim();

const stringToArray = x => isString(x) ? [x] : x;

const modifierObjectToArray = x => Array.isArray(x) ? x : Object.keys(x).filter(key => x[key] === true);

const toModifierArray = compose(modifierObjectToArray, stringToArray);

const onlyUseValidClassnames = arr => {
  // @ts-ignore
  const validNames = compose(reject(hasSpaces), reject(isEmptyString), map(trim), reject(isNotString))(arr);
  const removed = difference(arr, validNames).filter(x => x !== undefined);

  if (removed.length > 0) {
    console.warn(`removing bad classNames: ${removed[0] === '' ? 'empty space modifier' : removed}`);
  }

  return validNames;
};

const appendModifiersToBaseClass = baseClass => reduce((className, modifier) => `${className} ${baseClass}--${modifier}`, baseClass);

const classNameWithModifiers = curryN(2, (baseClass, ...args) => compose(appendModifiersToBaseClass(baseClass), uniq, onlyUseValidClassnames, flatten, map(toModifierArray), // @ts-ignore
reject(isFalsey))(args));

const formatIntelCount = count => {
  if (isNaN(count)) return NaN;

  if (count < 1000) {
    return `${count}`;
  }

  if (count >= 1000 && count < 10000) {
    const formattedCount = Math.floor(count / 100) / 10;
    return `${formattedCount}k`;
  }

  if (count >= 10000 && count < 1000000) {
    const formattedCount = Math.floor(count / 1000);
    return `${formattedCount}k`;
  }

  const formattedCount = Math.floor(count / 100000) / 10;
  return `${formattedCount}m`;
};

const formatDateTime = (date, formatString = undefined) => {
  return date && formatString ? moment(date, moment.ISO_8601).format(formatString) : date;
};
const formats = {
  dateTime: 'DD MMM YYYY',
  time: 'HH:mm',
  fullTime: moment.HTML5_FMT.TIME_SECONDS // "HH:mm:ss"

};
const formatDate = date => formatDateTime(date, formats.dateTime);
const formatTime = date => formatDateTime(date, formats.time);
const formatFullTime = date => formatDateTime(date, formats.fullTime);

export { classNameWithModifiers, formatDate, formatDateTime, formatFullTime, formatIntelCount, formatTime };
//# sourceMappingURL=index.js.map
